import { Wifi } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { ISPClientItem } from './ISPClientItem';
import type { ISPDownClient } from '../types';

interface Props {
  isp: string;
  clients: ISPDownClient[];
}

export function ISPGroupCard({ isp, clients }: Props) {
  return (
    <div className="rounded-lg border bg-card overflow-hidden" data-isp-client>
      {/* ISP Header */}
      <div className="flex items-center justify-between px-3 py-2 bg-muted/50 border-b">
        <div className="flex items-center gap-2">
          <Wifi className="h-4 w-4 text-destructive" />
          <span className="font-medium text-sm">{isp}</span>
        </div>
        <Badge variant="destructive" className="text-xs">
          {clients.length}
        </Badge>
      </div>

      {/* Clients list */}
      <div className="divide-y">
        {clients.map((client) => (
          <ISPClientItem key={client.sobid} client={client} />
        ))}
      </div>
    </div>
  );
}
